import apiFetch from '../apiFetch'

export default function (token, receiptFilterIncome) {
  return apiFetch({ endPoint: 'Report/ReceiptList/Download', method: 'POST', body: receiptFilterIncome, token: token, parseBlobAndAssign: true })
}
